var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "subscription-card",
      class: ((_obj = {}), (_obj[_vm.subscribe.plan.type] = true), _obj),
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "background" },
          [
            _c("DynamicSvg", {
              staticStyle: { width: "80px", height: "80px" },
              attrs: { name: _vm.subscribe.icon },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "subscription-description" }, [
          _c("div", [
            _c("div", { staticClass: "subscription-title" }, [
              _vm._v(_vm._s(_vm.subscribe.plan.title)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "subscription-alt-title" }, [
              _vm._v(_vm._s(_vm.subscribe.plan.altTitle)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subscription-details" }, [
            _c("div", { staticClass: "detail-item" }, [
              _vm.subscribe.plan.type === "supsis"
                ? _c("div", [_vm._v(_vm._s(_vm.$t("report.agentCount")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.subscribe.plan.type === "chatbot"
                ? _c("div", [_vm._v(_vm._s(_vm.$t("billing.sessionCount")))])
                : _vm._e(),
              _vm._v(" "),
              [
                "whatsapp",
                "whatsapp-business",
                "messenger",
                "instagram",
              ].includes(_vm.subscribe.plan.type)
                ? _c("div", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("billing.numberOfChannels")) +
                        "\n                    "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.$t("billing.subType")))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-value" }, [
              _c("div", [_vm._v(_vm._s(_vm.getValue()))]),
              _vm._v(" "),
              _c("div", [
                _vm._v(_vm._s(_vm.formatPeriod(_vm.subscribe.period))),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "remove-sub" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("delete")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }